<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>export default {
  data() {
    return {
      breadcrumb: [
        { name: "人员管理" },
        { name: "车队长管理" },
      ],
      menuIndex: `/staff/captain/table`,
      menu: [
        {
          name: "在职",
          path: `/staff/captain/table/1`,
        },
        {
          name: "离职",
          path: `/staff/captain/table/2`,
        },
        {
          name: "冻结",
          path: `/staff/captain/table/3`,
        },
      ],
    };
  },
  methods: {},
  mounted() {
    this.menuIndex = `${this.$route.path}`
  },
};
</script>
